










import { defineComponent, onBeforeUnmount, onMounted, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useEmailVerification from "@/hooks/useEmailVerification";
import useCheckVerificationCode from "@/hooks/useEmailVerification";
import providers from "@/lib/api";
import SixDigitConfirmView from "@/components/SixDigitConfirmView";

export default defineComponent({
  name: "SignUpEmailConfirmCode",
  components: { SixDigitConfirmView },
  setup(_, { emit }) {
    const { setUserVerificationStatus } = useEmailVerification();
    const { startPeriodicalConfirmationCheck, stopPeriodicalConfirmationCheck } = useCheckVerificationCode();
    const { authUser } = useAuthUser();
    const processingConfirmation = ref(false);

    const codeResend = () => {
      if (!authUser.value) return;
      providers.EmailVerificationProvider.start({ userId: authUser.value.id });
    };

    const submit = async (code: string) => {
      if (!authUser.value) return;
      try {
        processingConfirmation.value = true;
        const data = {
          userId: authUser.value.id,
          code,
        };

        const res = await providers.EmailVerificationProvider.verify({ data });
        await setUserVerificationStatus(res);
        if (res) {
          emit("login", true);
        }
      } finally {
        processingConfirmation.value = false;
      }
    };

    const onConfirmationSuccess = () => {
      emit("login", true);
    };

    onMounted(() => {
      startPeriodicalConfirmationCheck(onConfirmationSuccess);
    });

    onBeforeUnmount(() => {
      stopPeriodicalConfirmationCheck();
    });

    return {
      email: (authUser.value && authUser.value.email) || "",
      submit,
      codeResend,
      processingConfirmation,
    };
  },
});
